export default __webpack_public_path__ + "static/media/blob1.a29c2836.svg";